import React from "react";
import { useNavigate } from 'react-router-dom';

import { faBullhorn } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Stack, Tooltip } from "@mui/material";
import { iconSize, newsColor } from "../../App/GridRenderers";




const NewsBoardIcon = ({ mt = 0 }) => {
    const navigate = useNavigate();
    return (
        <div>
            <Stack sx={{ px: 2, pt: 2, mt: mt }}>
                <Tooltip title="News Board"
                    enterDelay={1000}>
                    <FontAwesomeIcon
                        icon={faBullhorn}
                        color={newsColor}
                        size={iconSize}
                        onClick={() => {
                            navigate("/newsboard")
                        }}
                    />
                </Tooltip>

            </Stack>
        </div >
    );
};

export default NewsBoardIcon;